import { zodResolver } from '@hookform/resolvers/zod'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useRemoteClientPost } from '../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { useToast } from '../../../../hooks'
import { SellFormSchema, sellSchema } from '../../../../validators/sell-validator'

export const FormActionSell = (clearCart: () => void, calculateItemsInCart: () => number, cart: any, sellType: string, memberId: string) => {
  const { showToast } = useToast()
  const { getUnitId } = useLocalStorage()
  const [isLoading, setIsLoading] = useState(false)

  const { httpClientPost } = useRemoteClientPost()

  const form = useForm<SellFormSchema>({
    resolver: zodResolver(sellSchema)
  })

  const onSubmitSell = async (data: SellFormSchema) => {
    try {
      if (calculateItemsInCart() == 0) {
        showToast('O carrinho está vazio', 'error')
        return
      }

      setIsLoading(true)

      if (sellType == 'VENDA_RAPIDA' && !memberId) {
        showToast('Selecione um cliente', 'error')
        return
      }

      const responseCart = await httpClientPost('/cestaCompras', {
        unidade: {
          id: getUnitId()
        },
        plano: cart.planos.map((data: any) => ({
          id: Number(data.id)
        })),
        servicos: cart.servicos.map((data: any) => ({
          quantidade: 1,
          servico: {
            id: Number(data.id)
          }
        })),
        produtos: cart.produtos.map((data: any) => ({
          quantidade: data.quantidade,
          produto: {
            id: Number(data.id)
          }
        }))
      })

      const body: any = {
        enviarEmailBoasVindas:true,
        cestaCompra: {
          id: responseCart.data.data.id
        },
        consultor: {
          id: data.consultor.id
        },
        idUsuario: data.consultor.id,
        idUnidade: getUnitId(),
        metodoPagamento: data.metodoPagamento,
        origem: sellType,
        ...(sellType == 'VENDA' ? { aluno: { id: Number(memberId) } } : { cliente: { id: Number(memberId) } })
      }

      if (data.metodoPagamento == 'CARTAO_CREDITO') {
        body.detalhesCartao = {
          tokenCartao: data.detalhesCartao?.tokenCartao,
          quantidadeParcelas: data.detalhesCartao?.quantidadeParcelas
        }
      }

      const responseSell = await httpClientPost('/vendas', body)

      if (data.metodoPagamento == 'BOLETO' || data.metodoPagamento == 'CARTAO_CREDITO') {
        const screenWidth = window.screen.width
        const screenHeight = window.screen.height
        const width = Math.min(800, screenWidth * 0.8)
        const height = Math.min(600, screenHeight * 0.8)
        const left = (screenWidth - width) / 2
        const top = (screenHeight - height) / 2
        const popupFeatures = `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`
        window.open(responseSell.data.data.urlPagamento, '_blank', popupFeatures)
      } else {
        showToast('Venda realizada com sucesso', 'success')
      }

      form.reset()
      clearCart()
    } catch (error) {
      CatchMessageError(error)
    } finally {
      setIsLoading(false)
    }
  }

  return {
    form,
    onSubmitSell,
    isLoading
  }
}
